exports.onRouteUpdate = () => {
  setTimeout(() => window.scrollTo(0, 0), 0)
}

exports.shouldUpdateScroll = () => false
